import { render } from "./ContentLibraryAdmin.vue?vue&type=template&id=bb51a9c4&scoped=true"
import script from "./ContentLibraryAdmin.vue?vue&type=script&lang=js"
export * from "./ContentLibraryAdmin.vue?vue&type=script&lang=js"

import "./ContentLibraryAdmin.vue?vue&type=style&index=0&id=bb51a9c4&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb51a9c4"]])

export default __exports__